import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { SOURCES_NAMES } from 'store/common/basket/constants';
import { onViewProductDay, onСlickProductDay } from 'store/SharedZone/actions';
import * as SharedZoneProductGoods from 'store/SharedZone/blocks/goods/selectors';
import commonStyles from 'styles/common.pcss';

import {
  BuyButton,
  FeedbackWidget,
  GoodsDayImage,
  GoodsDayInfo,
  GoodsDayLabel,
} from './components/index';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

const GoodsDayProduct = ({ goodDayProduct, isMobile, onMount, onProductClick, productId }) => {
  useEffect(() => {
    if (onMount) {
      onMount(goodDayProduct);
    }
  }, []);

  return (
    <div className={cx('component', isMobile && 'mobile')} data-indenty={productId}>
      <div className={cx('top', isMobile && 'mobile')}>
        <GoodsDayLabel className={cx('label')} />
        <FeedbackWidget className={cx('feedback')} id={productId} />
      </div>
      {/* <GoodDayTimer id={productId} /> */}
      <div className={cx('card', isMobile && 'mobile')}>
        <GoodsDayImage className={cx('imageWrap')} onClick={() => onProductClick(goodDayProduct)} />
        <div className={cx('info', isMobile ? 'mart-m' : 'marl-m')}>
          <GoodsDayInfo className={cx('title')} onClick={() => onProductClick(goodDayProduct)} />
          <BuyButton isMobile productId={productId} source={SOURCES_NAMES.SHOP_MAIN_PAGE} />
        </div>
      </div>
    </div>
  );
};

export const GoodsDayProductProps = {
  goodDayProduct: PropTypes.object,
  isMobile: PropTypes.bool,
  onMount: PropTypes.func,
  onProductClick: PropTypes.func,
  productId: PropTypes.number,
};

GoodsDayProduct.propTypes = GoodsDayProductProps;

const mapStateToProps = (state) => ({
  goodDayProduct: SharedZoneProductGoods.getGoodProduct(state),
  productId: SharedZoneProductGoods.getProductId(state),
});

const mapDispatchToProps = {
  onMount: onViewProductDay,
  onProductClick: onСlickProductDay,
};

export default SharedZoneProductGoods.connect(mapStateToProps, mapDispatchToProps)(GoodsDayProduct);
